import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { useClickOutside } from '../../../hooks'
import './styles.scss'

const appRoot = typeof window !== 'undefined' ? document.getElementById('___gatsby') : null

const SideNav = ({ active, handleClose, children }) => {
  const [scrollTop, setScrollTop] = useState(0) // set pixels to - from top when shownav = false
  const [bodyLocked, setBodyLock] = useState(false) // lock body while show nav = true
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  const sideNavRef = useRef()

  const closeSideNav = () => {
    if (active) {
      return handleClose()
    }
    return () => {}
  }

  useClickOutside(sideNavRef, closeSideNav)
  // C L O S E   O N   E S C   A N D   B O D Y   L O C K

  const handleEscKey = (event) => {
    // get rid of nav on esc keydown
    if (event.keyCode === 27 && handleClose) {
      closeSideNav()
    }
  }

  const lockBody = () => {
    // lock body while show nav true
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop
    setScrollTop(scrollPosition)
    document.body.style.top = `-${scrollPosition}px`
    document.body.classList.add('sidenav-open')
    setBodyLock(true)
  }

  const unlockBody = () => {
    // when show nav false, unlock body
    document.body.classList.remove('sidenav-open')
    document.body.style.top = '0px'
    window.scrollTo(0, scrollTop)
    setScrollTop(0)
    setBodyLock(false)
  }

  // use effect exit menu on sec keydown
  useEffect(() => {
    document.addEventListener('keydown', handleEscKey)
    return () => {
      unlockBody()
      document.removeEventListener('keydown', handleEscKey)
    }
  }, [])

  // use effect when shownav updated
  useEffect(() => {
    if (active && !bodyLocked) lockBody()
    if (!active && bodyLocked) unlockBody()
  }, [active])

  if (!mounted) return null

  return ReactDOM.createPortal(
    <nav className={`sidenav ${active ? 'active' : ''}`} ref={sideNavRef}>
      {children}
    </nav>,
    appRoot
  )
}

export default SideNav
